<div class="dialog">
  <div class="dialog-box">
    <h2 mat-dialog-title>{{local_data.title}}</h2>
  </div>
  <div class="dialog-box-s">
    <div class="dialog-box dialog-box-m">
      <input class="center-input" type="file" accept=".xls,.xlsx" (change)="selectFile($event)">
    </div>
    @if (invalidInput) {
      <mat-hint class="error-hint">{{errorMessage}}</mat-hint>
    }
  </div>
  <div class="dialog-box-s">
    <mat-dialog-actions class="button-group">
      <app-button typeBtn="secondary" color="red" textColor="white" message="{{variables.goBack}}" mat-dialog-close></app-button>
      <app-button typeBtn="primary" (click)="uploadFile()" message="{{variables.confirm}}"></app-button>
    </mat-dialog-actions>
  </div>
</div>
